// components/ErrorMessage.jsx
import React from 'react';

export default function ErrorMessage({ message, onClose }) {
  if (!message) return null;

  return (
    <div className="error-message visible">
      <div className="error-icon">
        <span className="material-icons">error</span>
      </div>
      <div className="error-text">{message}</div>
      <button className="close-button" onClick={onClose} aria-label="Sluit foutmelding">
        <span className="material-icons">close</span>
      </button>
    </div>
  );
}